<template>
  <div class="recaptcha-failure">
    <h1>Sorry, We've Encountered a Small Issue</h1>

    <p>We've noticed some unusual activity during your login attempt. This could be due to:</p>

    <ul>
      <li>An unstable internet connection</li>
      <li>Use of a VPN or proxy server</li>
      <li>Browser settings that may affect the verification process</li>
      <li>Temporary technical issues on our end</li>
    </ul>

    <p>Please don't worry, this happens from time to time and doesn't mean you've done anything wrong.</p>

    <h2>You can try the following steps:</h2>

    <ol>
      <li>Refresh the page and try again</li>
      <li>Clear your browser cache and cookies</li>
      <li>Temporarily disable your VPN or proxy service (if you're using one)</li>
      <li>Try logging in using a different browser or device</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'RecaptchaFailure',
}
</script>

<style scoped>
.recaptcha-failure {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  color: #333;
}

ul, ol {
  margin-left: 20px;
}
</style>